import React from 'react';
import { useTranslation } from 'react-i18next';
import { PricingPreviewMessages as M } from './PricingPreview.messages';
import { PlanNameMessages } from '../common/PlanName.messages';
import { PlanFreeIcon, PlanStarterIcon, PlanGrowthIcon, PlanScaleIcon } from '../../design-system/components/SvgIcons';

interface PricingPreviewProps {
  onViewPlans: () => void;
}

export const PricingPreview: React.FC<PricingPreviewProps> = ({ onViewPlans }) => {
  const { t } = useTranslation();

  const plans = [
    { name: t(PlanNameMessages.FREE), price: t(M.FREE_PRICE), suffix: t(M.FOREVER), words: t(M.FREE_WORDS), icon: <PlanFreeIcon size={32} /> },
    { name: t(PlanNameMessages.STARTER), price: t(M.STARTER_PRICE), suffix: t(M.PER_MONTH), words: t(M.STARTER_WORDS), icon: <PlanStarterIcon size={32} /> },
    { name: t(PlanNameMessages.GROWTH), price: t(M.GROWTH_PRICE), suffix: t(M.PER_MONTH), words: t(M.GROWTH_WORDS), popular: true, icon: <PlanGrowthIcon size={32} /> },
    { name: t(PlanNameMessages.SCALE), price: t(M.SCALE_PRICE), suffix: t(M.PER_MONTH), words: t(M.SCALE_WORDS), icon: <PlanScaleIcon size={32} /> },
  ];

  const features = [t(M.FEATURE_LOCALES), t(M.FEATURE_CLI), t(M.FEATURE_DASHBOARD), t(M.FEATURE_VARIABLES)];

  return (
    <section className="pricing-preview">
      <div className="container">
        <div className="section-header">
          <h2>{t(M.TITLE)}</h2>
          <p className="section-subtitle">{t(M.SUBTITLE)}</p>
        </div>
        <div className="pricing-grid">
          {plans.map((plan, i) => (
            <div className={`pricing-card${plan.popular ? ' popular' : ''}`} key={i}>
              <div style={{ marginBottom: '6px' }}>{plan.icon}</div>
              <div className="pricing-plan-name">{plan.name}</div>
              <div className="pricing-plan-price">{plan.price}<span> {plan.suffix}</span></div>
              <div className="pricing-plan-words">{plan.words}</div>
              <ul className="pricing-plan-features">
                {features.map((f, j) => <li key={j}>{f}</li>)}
              </ul>
            </div>
          ))}
        </div>
        <div className="pricing-cta-row">
          <button className="btn btn-primary" onClick={onViewPlans}>{t(M.BTN_VIEW_PLANS)}</button>
          <p className="pricing-note">{t(M.NO_CC)}</p>
        </div>
      </div>
    </section>
  );
};
